import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosInstanceForm } from "../../../Utils/AxiosInstance";

export const importCsv = createAsyncThunk(
  "csvImport/importCsv",
  async ({ file, projectId, sectionId }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("ProjectId", projectId);
      formData.append("SectionId", sectionId);

      const response = await axiosInstanceForm.post("Units/Unit/Import", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      // Handle partial success case
      if (response.data.errors && response.data.errors.length > 0) {
        return rejectWithValue(response.data);
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const CsvImportSlice = createSlice({
  name: "CsvImport",
  initialState: {
    loading: false,
    success: false,
    error: null,
    response: null,
    errors: [],
    partialSuccess: false,
  },
  reducers: {
    resetImportState: state => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.response = null;
      state.errors = [];
      state.partialSuccess = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(importCsv.pending, state => {
        state.loading = true;
        state.success = false;
        state.error = null;
        state.response = null;
        state.errors = [];
        state.partialSuccess = false;
      })
      .addCase(importCsv.fulfilled, (state, action) => {
        state.loading = false;
        state.response = action.payload;
        state.success = true;
        state.errors = [];
        state.partialSuccess = false;
      })
      .addCase(importCsv.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || action.error.message;

        // Handle partial success case
        if (Array.isArray(action.payload?.errors)) {
          state.errors = action.payload.errors;
          state.partialSuccess = true;
          state.response = action.payload;
        } else {
          state.errors = [];
          state.success = false;
          state.partialSuccess = false;
        }
      });
  },
});

export const { resetImportState } = CsvImportSlice.actions;
export default CsvImportSlice.reducer;
